import styled from "styled-components";

export const GoalSelectionResultWrapper = styled.div`
  .MuiGrid2-root {
    padding-right: 0px !important;
  }

  .width-100 {
    width: 100%;
  }

  .goal-name-link {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
